var map = {
	"./Java_logo.png": 161,
	"./address_image.svg": 162,
	"./animated_logo.svg": 163,
	"./aws.jpg": 164,
	"./blogs_image.svg": 165,
	"./charan_photo.png": 166,
	"./cloud_infrastructure.svg": 167,
	"./codeInLogo.png": 168,
	"./codingninja.png": 169,
	"./contactMail.png": 170,
	"./coursera_logo.png": 171,
	"./data_science.svg": 172,
	"./deeplearning_ai_logo.png": 173,
	"./delhivery_logo.png": 174,
	"./developerActivity.svg": 175,
	"./dsc_logo.png": 176,
	"./education.svg": 177,
	"./experience.svg": 178,
	"./feelingProud.svg": 179,
	"./freecopy_logo.png": 180,
	"./fullstack.svg": 181,
	"./gcp_logo.png": 182,
	"./github_logo.png": 183,
	"./globalshala_logo.png": 184,
	"./google.png": 185,
	"./googleAssistant.jpg": 186,
	"./googleAssistant.svg": 187,
	"./google_logo.png": 188,
	"./ibm_logo.png": 189,
	"./iiitk_logo.png": 190,
	"./inai_logo.png": 191,
	"./intel.jpg": 192,
	"./intel_logo.jpg": 193,
	"./jsFramework.svg": 194,
	"./legato_logo.png": 195,
	"./manOnTable.svg": 196,
	"./microsoft_logo.png": 197,
	"./mlrit_logo.png": 198,
	"./mlritcie.jpg": 199,
	"./mlritscope.jpg": 200,
	"./mozilla_logo.png": 201,
	"./muffito_logo.png": 202,
	"./nextuLogo.jpg": 203,
	"./nptel_logo.png": 204,
	"./nss.png": 205,
	"./portfolio.gif": 206,
	"./programmer.svg": 207,
	"./projects_image.svg": 208,
	"./pwa.png": 209,
	"./saayaHealthLogo.png": 210,
	"./stanford_logo.png": 211,
	"./talksCardBack.svg": 212,
	"./talksCardBackAlt.svg": 213,
	"./tlearn.jpg": 214,
	"./uf_logo.png": 215,
	"./ui_ux_design.svg": 216,
	"./um.jpg": 217,
	"./virtusa.png": 218,
	"./vivekananda.png": 219
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 53;